import React, { useEffect, useState } from 'react'
import { PlusOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button, Input, Modal, Select, message } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { deleteBrand, fetchBrandList } from '../../apis/brand'
import { fetchGroupList } from '../../apis/group'
import { SearchWrapper } from '../DataSource/dataSource.styled'
import useParams from '../../hook/useParams'
import { WhiteWrapper } from './group.styled'
import MainTable from '../../components/Basic/MainTable'
import dayjs from 'dayjs'
import BrandModal from './modals/BrandModal'

function BrandList (props) {
  const { adminMode, setNowTab, setBrand, setGroup } = props
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const params = useParams()
  const { handleFetchParams, fetchParams } = params
  const userGroupOptions = user?.groups?.map(i => ({ value: i.id, label: i.name })) || []

  const [groupsOption, setGroupsOption] = useState(userGroupOptions)
  const [showModal, setShowModal] = useState(false)
  const [modalData, setModalData] = useState({})

  const handleRedirect = record => {
    setNowTab('user')
    setBrand(record?.id)
    if (adminMode) setGroup()
  }

  const handleAdd = () => {
    setModalData({ addMode: true })
    setShowModal(true)
  }
  const handleEdit = record => {
    setModalData(record)
    setShowModal(true)
  }
  const handleDelete = record => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t('group.brand')}`,
      content: `${ln_t('message.confirm.delete')} ${record.name}?`,
      onOk: async () => {
        const result = await deleteBrand(record?.id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const apiFunc = async () => fetchBrandList(fetchParams)
  const formatDate = (data, detail) => dayjs(data).format(`YYYY-MM-DD${detail ? ' hh:mm:ss' : ''}`)
  const columns = [
    {
      title: ln_t('group.name'),
      dataIndex: 'name',
      render: (name, record) => <div style={{ color: 'var(--primary', cursor: 'pointer' }} onClick={() => handleRedirect(record)}>{name}</div>
    },
    { title: ln_t('group.segmentLimit'), dataIndex: 'limits', sorter: true, render: e => e?.segmentLimit || ln_t('util.notSettingYet') },
    { title: ln_t('group.status'), dataIndex: 'status', sorter: true, render: e => e ? ln_t('util.enable') : ln_t('util.disable') },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', sorter: true, render: e => formatDate(e) },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', sorter: true, render: e => formatDate(e, true) },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, record) => <div className="action-btn">
        <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
        <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
      </div>
    }
  ]

  const successCallback = () => {
    message.success(ln_t('message.success.create'))
    handleFetchParams('add', {})
  }

  const getGroups = async () => {
    const result = await fetchGroupList({ maxResults: 1000, sort: '-updatedAt' })
    if (result?.status === 200) setGroupsOption(result?.data.map(i => ({ value: i.id, label: i.name })))
  }
  useEffect(() => {
    if (adminMode) {
      getGroups()
      return
    }
    handleFetchParams('add', { groupId: user?.nowGroup })
  }, [])

  return (
    <WhiteWrapper>
      <h3>{ln_t('group.brand')}</h3>
      <SearchWrapper>
        <div style={{ display: 'flex' }}>
          <Input.Search
            allowClear
            style={{ width: '400px' }}
            placeholder={ln_t('util.search')}
            onSearch={e => handleFetchParams('add', { name_like: `%${e}%` })}
            enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
          />
          {adminMode
            ? <div className="d-flex">
                <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.group')} :</div>
                <Select
                  showSearch
                  style={{ minWidth: '120px' }}
                  defaultValue="all"
                  placeholder={`${ln_t('util.select')} ${ln_t('util.group')}`}
                  options={[{ value: 'all', label: 'ALL' }, ...groupsOption]}
                  optionFilterProp="children"
                  onChange={e => handleFetchParams('add', { groupId: e === 'all' ? undefined : e })}
                />
              </div>
            : ''}
        </div>
        <Button type="default" icon={<PlusOutlined />} onClick={() => handleAdd()}>
          {ln_t('util.add')} {ln_t('group.brand')}
        </Button>
      </SearchWrapper>
      <MainTable
        columns={columns}
        rowKey="id"
        apiFunc={apiFunc}
        params={params}
      />
      <BrandModal
        {...props}
        show={showModal}
        setShow={setShowModal}
        data={modalData}
        successCallback={successCallback}
        groupsOption={groupsOption}
      />
    </WhiteWrapper>
  )
}

export default BrandList
